import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { default as ngLang } from '@angular/common/locales/en';
import { APP_INITIALIZER, NgModule, Type } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// import { ApiModule, Configuration } from '@lamta/inventory-client';
// import { TokenService } from '@services/sys/token.service';
import { zhCN as dateLang } from 'date-fns/locale';
import { en_US as zorroLang } from 'ng-zorro-antd/i18n';
import { en_US, NZ_I18N } from 'ng-zorro-antd/i18n';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { NzNotificationModule } from 'ng-zorro-antd/notification';
import { GANTT_GLOBAL_CONFIG } from '@worktile/gantt';

const LANG = {
    abbr: 'en',
    ng: ngLang,
    zorro: zorroLang,
    date: dateLang,
};
import { registerLocaleData } from '@angular/common';

registerLocaleData(LANG.ng, LANG.abbr);
const LANG_PROVIDES = [{ provide: NZ_I18N, useValue: en_US }];
// #endregion

// #endregion

// #region Startup Service
import { DefaultInterceptor, StartupService } from '@core';

const INTERCEPTOR_PROVIDES = [{ provide: HTTP_INTERCEPTORS, useClass: DefaultInterceptor, multi: true }];
// #endregion

// #region global third module
const GLOBAL_THIRD_MODULES: Type<any>[] = [];
// #endregion

export function StartupServiceFactory(startupService: StartupService): () => Promise<void> {
    return () => startupService.load();
}

const APPINIT_PROVIDES = [
    StartupService,
    {
        provide: APP_INITIALIZER,
        useFactory: StartupServiceFactory,
        deps: [StartupService],
        multi: true,
    },
    // {
    //     provide: Configuration,
    //     useFactory: (tokenService: TokenService) => new Configuration(
    //         {
    //             basePath: location.origin,
    //             accessToken: tokenService.getToken.bind(TokenService)
    //         }
    //     ),
    //     deps: [TokenService],
    //     multi: false
    // }
];
// #endregion

const GANTT__PROVIDES = [
    {
        provide: GANTT_GLOBAL_CONFIG,
        useValue: {
            locale: 'en-us',
            timeZone: 'America/New_York'  // or your local time zone
        }
    }
]

import { SharedModule } from '@shared';
import { TaskSharedModule } from '@task-shared';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';

@NgModule({ declarations: [AppComponent],
    bootstrap: [AppComponent], imports: [
        // ApiModule,
        BrowserModule,
        BrowserAnimationsModule,
        CoreModule,
        SharedModule,
        TaskSharedModule,
        AppRoutingModule,
        NzMessageModule,
        NzNotificationModule,
        ...GLOBAL_THIRD_MODULES], providers: [...LANG_PROVIDES, ...INTERCEPTOR_PROVIDES, ...APPINIT_PROVIDES, ...GANTT__PROVIDES, provideHttpClient(withInterceptorsFromDi())] })
export class AppModule {}
